// This file was auto-generated by Fern from our API Definition.
export const SpanType = {
    Agent: "agent",
    Chain: "chain",
    Workflow: "workflow",
    Task: "task",
    Tool: "tool",
    Embedding: "embedding",
    Query: "query",
    Llm: "llm",
    Completion: "completion",
    Chat: "chat",
    Rerank: "rerank",
    Unknown: "unknown",
};
